export const formatNumber = (
  num: number,
  options?: Intl.NumberFormatOptions,
) => {
  return new Intl.NumberFormat(undefined, options).format(num);
};
